"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_1 = require("react-router");
var useAuth_1 = require("../../useAuth");
var AuthStatus_1 = require("../../AuthStatus");
var config_1 = require("../../../config");
var cache_1 = require("../../../cache");
var AuthenticateLoader_1 = (0, tslib_1.__importDefault)(require("../AuthenticateLoader"));
var Authenticate = function () {
    var history = (0, react_router_1.useHistory)();
    var authState = (0, useAuth_1.useAuth)().authState;
    var defaultPath = (0, config_1.useNTConfig)().MicroFE.defaultPath;
    (0, react_1.useEffect)(function () {
        if (authState === AuthStatus_1.AuthStatus.LOGGED_IN) {
            setTimeout(function () {
                var route = cache_1.fosCache.getItem(cache_1.LOGIN_REQUEST_URI) || defaultPath;
                history.replace(route);
            });
        }
    }, [authState, history, defaultPath]);
    return react_1.default.createElement(AuthenticateLoader_1.default, { text: "Signing In..." });
};
exports.default = Authenticate;
